import { render, staticRenderFns } from "./FacialDeviceModal.vue?vue&type=template&id=430ad580&scoped=true&"
import script from "./FacialDeviceModal.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430ad580",
  null
  
)

export default component.exports